import { api } from '~/api';
import { captureException } from '~/utils/exception-tracking';

/**
 *
 * @param {string} source
 *
 * @description api call to trigger User Subscribe event - which will subscribe
 * the customer to SMS notificatons. When implementing this, please
 * pass a source that is relevant to the event. For example, if the
 * user subscribes to SMS from the checkout page, use SmsSource.CHECKOUT.
 */
export const smsSubscribe = async (source) => {
  if (!source) {
    captureException(new Error('Error missing source when subscribing to SMS'));
  }

  try {
    await api.sms.subscribe(source);
  } catch (err) {
    captureException(new Error('Error subscribing customer to SMS'), {
      extras: { error: JSON.stringify(err) },
    });
  }
};
